var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                adChannel: false,
                adPlacement: false,
                isCountry: false,
                isDate: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { filterable: "", placeholder: "请选择" },
                  on: { change: _vm.getServer },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择服务器"
                  },
                  on: { change: _vm.serverListChange },
                  model: {
                    value: _vm.paramsData.server_ids,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_ids", $$v)
                    },
                    expression: "paramsData.server_ids"
                  }
                },
                _vm._l(_vm.serverList, function(item) {
                  return _c("el-option", {
                    key: item.serverID,
                    attrs: {
                      label: item.serverName,
                      value: item.serverID + "+" + item.openTimeTimestamp
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.paramsData.server_ids.length
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: "开服第几天"
                      },
                      model: {
                        value: _vm.paramsData.open_server_day,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "open_server_day", $$v)
                        },
                        expression: "paramsData.open_server_day"
                      }
                    },
                    _vm._l(_vm.dayList, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: "角色ID", clearable: "" },
                model: {
                  value: _vm.paramsData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_id", $$v)
                  },
                  expression: "paramsData.role_id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 8 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !this.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v("导出")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "server_id", label: "服务器" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_day", label: "开服第几天" }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_id", label: "角色ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_name", label: "角色名字" }
          }),
          _c("el-table-column", {
            attrs: { prop: "duration", label: "角色当日游玩时长" }
          }),
          _c("el-table-column", {
            attrs: { prop: "level", label: "角色等级" }
          }),
          _c("el-table-column", {
            attrs: { prop: "fighting", label: "角色战力" }
          }),
          _c("el-table-column", {
            attrs: { prop: "main_line_task", label: "主线关卡" }
          }),
          _c("el-table-column", { attrs: { prop: "pata", label: "爬塔层数" } }),
          _c("el-table-column", {
            attrs: { prop: "total_amount", label: "累计充值" }
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.currentPage,
          total: _vm.tableCopyTableList.length,
          "page-size": _vm.pageSize
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }